// Adds UTM tracking parameters to Agribegri product links in AI-generated text, so traffic coming
// from AI recommendations can be identified in analytics. Only product pages (/products/<slug>)
// are tagged; category, blog and home links are left exactly as written.
const UTM_QUERY = new URLSearchParams({
  utm_source: 'ai',
  utm_medium: 'comment',
  utm_campaign: 'product_recommendation',
}).toString();

// 1: character before the link (so "notagribegri.com", "a@agribegri.com" and "?to=agribegri.com"
//    are skipped), 2: scheme + host, 3: path, query and hash. The lookahead rejects hosts such as
//    "agribegri.community" and "agribegri.com.evil.com".
const AGRIBEGRI_LINK = /(^|[^\w@./=%-])((?:https?:\/\/)?(?:www\.)?agribegri\.com)(?![\w-]|\.\w)([/?#][^\s<>"]*)?/gi;
const TRAILING_PUNCTUATION = /[.,;:!?)\]}'”’]+$/;
// "/products/" followed by a slug, not just "/products/" or "/products/?page=2".
const PRODUCT_PATH = /^\/products\/[^?#]/i;
const HAS_UTM_PARAM = /[?&]utm_[^=&#]*=/i;

// `rest` is everything after the host: "/products/x.php?a=1#top". Existing UTM parameters are left
// alone so a link that is already tagged is never changed or duplicated. Only the query string
// is appended to, so the rest of the URL stays exactly as written.
const tagProductLink = (rest) => {
  const hashAt = rest.indexOf('#');
  const path = hashAt === -1 ? rest : rest.slice(0, hashAt);
  const hash = hashAt === -1 ? '' : rest.slice(hashAt);
  if (HAS_UTM_PARAM.test(path)) return rest;

  const separator = !path.includes('?') ? '?' : /[?&]$/.test(path) ? '' : '&';
  return `${path}${separator}${UTM_QUERY}${hash}`;
};

export const addAiUtmParams = (text) => {
  if (typeof text !== 'string') return text;
  return text.replace(AGRIBEGRI_LINK, (match, before, host, rest = '') => {
    // "...product-x." should tag the link, not the full stop after it.
    const link = rest.replace(TRAILING_PUNCTUATION, '');
    if (!PRODUCT_PATH.test(link)) return match;
    return `${before}${host}${tagProductLink(link)}${rest.slice(link.length)}`;
  });
};
